import { render, staticRenderFns } from "./ProductContentSidebar.vue?vue&type=template&id=ad1df378&scoped=true&"
import script from "./ProductContentSidebar.vue?vue&type=script&lang=js&"
export * from "./ProductContentSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ProductContentSidebar.vue?vue&type=style&index=0&id=ad1df378&prod&scoped=true&lang=css&"
import style1 from "./ProductContentSidebar.vue?vue&type=style&index=1&id=ad1df378&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad1df378",
  null
  
)

export default component.exports